export default __webpack_public_path__ + "static/media/ofilsystem.76327132.jpg";